/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ToolBarAutoItemsController", ["ControllerPlaceholderBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class ToolBarAutoItemsController
   * @memberOf classes
   * @extends classes.ControllerPlaceholderBase
   */
  class ToolBarAutoItemsController extends cls.ControllerPlaceholderBase /** @lends classes.ToolBarAutoItemsController.prototype */ {
    static __name = "ToolBarAutoItemsController";

    constructor(bindings) {
      super(bindings);
      this._autoWidgetType = "ToolBarItem";
      this._affectLayout = true;

      if (bindings.anchor.attribute("content") === "actions") {
        if (!this.isInChromeBar()) {
          this._registerActionHandlers();
        }
      } else if (bindings.anchor.attribute("content") === "programs") {
        if (!this.isInChromeBar()) {
          this._registerProgramsHandlers();
        }
      } else if (bindings.anchor.attribute("content") === "windows") {
        if (!this.isInChromeBar()) {
          this._registerWindowsHandlers();
        }
      }
    }

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // 4st behaviors
      this._addBehavior(cls.FontStyle4STBehavior, true);
      this._addBehavior(cls.FontSize4STBehavior, true);
      this._addBehavior(cls.FontColor4STBehavior, true);
      this._addBehavior(cls.Border4STBehavior, true);
      this._addBehavior(cls.Reverse4STBehavior, true);

      this._addBehavior(cls.ScaleIcon4STBehavior, true, true);
      this._addBehavior(cls.DefaultTTFColor4STBehavior);

      // vm behaviors
      this._addBehavior(cls.EnabledButtonVMBehavior);
      this._addBehavior(cls.HiddenVMBehavior);
      this._addBehavior(cls.ColorVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.FontWeightVMBehavior);
      this._addBehavior(cls.TextDecorationVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);
      this._addBehavior(cls.ImageVMBehavior);
      this._addBehavior(cls.TitleVMBehavior);
      this._addBehavior(cls.TextActionVMBehavior);

      // ScaleIcon requires that the image is already present
      this._addBehavior(cls.ScaleIcon4STBehavior, true, true);
    }

    _getWidgetType(kind, active) {
      let type = "ToolBarPlaceholder";

      const chromeBarTheme = this.isInChromeBar();
      if (chromeBarTheme) {
        type = "ChromeBarPlaceholder";
      }

      return type;
    }
  }

  cls.ToolBarAutoItemsController = ToolBarAutoItemsController;
  cls.ControllerFactory.register("ToolBarAutoItems", cls.ToolBarAutoItemsController);
});
